import React from "react";
import { Route, Routes } from "react-router-dom";
import AppVersionList from "../layout/appVersion/AppVersionList";
import AddAndEditAppVersion from "../layout/appVersion/AddAndEditAppVersion";

const AppVersionPage = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<AppVersionList />} />
        <Route path="/add" element={<AddAndEditAppVersion />} />
        <Route path="/update/:platform" element={<AddAndEditAppVersion />} />
      </Routes>
    </>
  );
};

export default AppVersionPage;
